import styled, { css } from 'styled-components'

type Props = {
  value: 'active' | 'blocked'
  active?: boolean
  onClick: () => void
}

export const FilterByActivityOption: React.FC<Props> = ({
  value,
  onClick,
  active = false,
}) => (
  <Root type="button" $active={active} onClick={onClick} $type={value}>
    {value}
  </Root>
)

const Root = styled.button<{
  $active: boolean
  $type: 'active' | 'blocked'
}>`
  border: 1px solid var(--background-4);

  font-size: 11px;
  font-weight: 700;
  border-radius: 10px;
  height: 30px;
  gap: 4px;

  display: grid;
  justify-content: center;
  align-items: center;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  transition: all 0.15s linear;
  cursor: pointer;

  color: ${({ $type }) =>
    $type === 'active' ? 'var(--upAccent-9)' : 'var(--downAccent-9)'};
  background: ${({ $active }) =>
    $active ? 'var(--background-3)' : 'transparent'};

  &:hover {
    background: ${({ $type }) =>
      $type === 'active'
        ? 'rgba(var(--upAccent-9-rgb), 0.1)'
        : 'rgba(var(--downAccent-9-rgb), 0.1)'};
    border-color: ${({ $type }) =>
      $type === 'active' ? 'var(--upAccent-9)' : 'var(--downAccent-9)'};
  }

  ${({ $type, $active }) =>
    $active &&
    css`
      border: 1px solid var(--background-6);
      background: var(--background-3);

      background: ${$type === 'active'
        ? 'rgba(var(--upAccent-9-rgb), 0.1)'
        : 'rgba(var(--downAccent-9-rgb), 0.1)'};
      border-color: ${$type === 'active'
        ? 'var(--upAccent-9)'
        : 'var(--downAccent-9)'};
      color: ${$type === 'active'
        ? 'var(--upAccent-9)'
        : 'var(--downAccent-9)'};
    `}
`
